var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 13,
    viewBox: "0 0 6 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.6 11.7984C0.268629 11.7984 0 12.067 0 12.3984C0 12.7297 0.268629 12.9984 0.6 12.9984H5.4C5.73137 12.9984 6 12.7297 6 12.3984C6 12.067 5.73137 11.7984 5.4 11.7984H0.6ZM0.393712 6.1944C0.628026 5.96009 1.00793 5.96009 1.24224 6.1944L2.40004 7.3522L2.40004 1.59586C2.40004 1.26449 2.66867 0.995861 3.00004 0.995861C3.33141 0.995861 3.60004 1.26449 3.60004 1.59586L3.60004 7.35193L4.75757 6.1944C4.99188 5.96009 5.37178 5.96009 5.6061 6.1944C5.84041 6.42871 5.84041 6.80861 5.6061 7.04293L3.42417 9.22486C3.18985 9.45917 2.80996 9.45917 2.57564 9.22486L0.393712 7.04293C0.159397 6.80861 0.159397 6.42871 0.393712 6.1944Z",
    fill: "#2468FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.fe12434d9e9856ae037c83fcd6a79f22.svg";
export { ForwardRef as ReactComponent };